import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, of } from 'rxjs';

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.less'],
})
export class LayoutComponent implements OnInit {
  profile: any = {
    name: '',
    role: {
      code: '',
    },
  };

  isMenuDrawerVisible: boolean = false;

  constructor(
    private readonly router: Router,
    private readonly httpClient: HttpClient
  ) {}

  ngOnInit(): void {
    this.httpClient
      .get('/users/profile')
      .pipe(catchError(() => of()))
      .subscribe((response: any) => {
        this.profile = response;
      });
  }

  menuItems = [
    {
      name: 'ទំព័រដើម',
      icon: 'home',
      to: '/',
      disabled: false,
    },
    {
      name: 'អំពីអ្នក',
      icon: 'user',
      to: '/profile/about',
      disabled: false,
    },
    {
      name: 'គ្រប់គ្រង់គណនី',
      icon: 'setting',
      to: '/account/setting',
      disabled: false,
    },
    {
      name: 'ពិន្ទុ',
      icon: 'wallet',
      to: '/account/point',
      disabled: false,
    },
    {
      name: 'វិញ្ញាបនប័ត្រ',
      icon: 'file-protect',
      to: '/account/certificate',
      disabled: true,
    },
  ];

  superAdminMenuItems = [
    {
      name: 'សមាជិកសមាគម',
      icon: 'team',
      to: '/admin/users',
      disabled: false,
    },
    {
      name: 'ស្នើសុំចូលសមាជិក',
      icon: 'user-add',
      to: '/admin/request',
      disabled: false,
    },
    {
      name: 'អង្គភាព',
      icon: 'apartment',
      to: '/admin/organization',
      disabled: false,
    },
    {
      name: 'សកម្មភាពមនុស្សធម៌',
      icon: 'fund',
      to: '/admin/campaign',
      disabled: false,
    },
  ];

  logoutClicked() {
    window.localStorage.removeItem('accessToken');
    this.router.navigateByUrl('/account/signin');
  }

  openHelp() {
    window.open('https://t.me/cicca_live_support');
  }
}
